import BulkEditAlarms from '@/pages/Alarms/BulkEdit';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

WiseMetering.Views.BulkEditAlarms = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function() {
        this.reactRoot = createRoot(document.getElementById(this.id));
        this.reactRoot.render(<BulkEditAlarms alarms={ this.options.alarms }/>);
    },

    onClose: function() {
        if (this.reactRoot) {
            this.reactRoot.unmount(); // Unmount the React component
            this.reactRoot = null; // Clean up reference
        }
    }
});
